import { render, staticRenderFns } from "./CampanyTable.vue?vue&type=template&id=66560e7c"
import script from "./CampanyTable.vue?vue&type=script&lang=js"
export * from "./CampanyTable.vue?vue&type=script&lang=js"
import style0 from "./CampanyTable.vue?vue&type=style&index=0&id=66560e7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports